import axios from 'axios'

import runtimeConfig from './runtime'

const getEndpoints = ({ country, locale }) => {
  return {
    default: {
      client: axios.create({
        baseURL: `${runtimeConfig.apiUrl}/api`,
        responseType: 'json',
        headers: {
          Locale: locale?.toString().toUpperCase()
        }
      })
    },
    identity: {
      client: axios.create({
        baseURL: runtimeConfig.identityAuthorityURL,
        responseType: 'json',
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
        }
      })
    }
  }
}

export default getEndpoints
